import React from "react";

const Title = ({ title, additionalStyles }) => {
  const titleStyle = {
    display: "-webkit-box",
    WebkitBoxOrient: "vertical",
    WebkitLineClamp: 2,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "normal",
    lineHeight: "1.2em",
    // maxHeight: "2.4em",
  };
  const titleContainerStyle = {
    position: "relative",
    zIndex: 20,
    color: "#fefefe",
    fontWeight: "bold",
    height: "55px",
    borderRadius: "0px 0px 10px 10px",
    padding: "12px",
    fontSize: "16px",
    display: "flex",
    alignItems: "flex-end",
    overflow: "hidden",
  };

  return (
    <div style={{ ...additionalStyles, ...titleContainerStyle }}>
      <span style={titleStyle}>{title}</span>
    </div>
  );
};

export default Title;
